import { Injectable, inject, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class EmpresaLogoService {
  private http = inject(HttpClient);
  private readonly BUSINESS_URL = `${environment.apiUrl}/logo`;

  /** URL del logo de la empresa (vacío si no tiene) */
  private _logoUrl = signal<string>('');

  /** Indica si ya se cargó el logo */
  private _loaded = signal(false);

  /** URL del logo de la empresa. Vacío si no tiene logo configurado */
  readonly logoUrl = this._logoUrl.asReadonly();

  /** true si la empresa tiene un logo custom configurado */
  readonly hasCustomLogo = computed(() => this._logoUrl().length > 0);

  /**
   * Carga el logo de la empresa desde el backend.
   * Se llama una vez al inicializar el layout.
   */
  loadLogo(): void {
    if (this._loaded()) return;

    this.http.get<ApiResponse<{ logoUrl: string }>>(this.BUSINESS_URL).subscribe({
      next: (response) => {
        if (response.success && response.data?.logoUrl) {
          this._logoUrl.set(response.data.logoUrl);
        }
        this._loaded.set(true);
      },
      error: () => {
        this._loaded.set(true);
      }
    });
  }

  /**
   * Sube un nuevo logo de empresa.
   * Actualiza el signal automáticamente al completar.
   */
  uploadLogo(file: File): void {
    const formData = new FormData();
    formData.append('logo', file);

    this.http.post<ApiResponse<{ logoUrl: string }>>(`${this.BUSINESS_URL}/upload`, formData).subscribe({
      next: (response) => {
        if (response.success && response.data?.logoUrl) {
          this._logoUrl.set(response.data.logoUrl);
        }
      }
    });
  }

  /**
   * Actualiza el logo URL manualmente (para sincronizar después de upload externo).
   */
  setLogoUrl(url: string): void {
    this._logoUrl.set(url);
  }

  /**
   * Resetea el estado (para logout).
   */
  reset(): void {
    this._logoUrl.set('');
    this._loaded.set(false);
  }
}
